import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '~/app/services/auth/auth.store'
import { AUTH_PATH } from '~/app/lib/paths'
import TenantSelection from '~/app/components/modules/TenantSelection'

export default function TenantSelectionPage() {
  const navigate = useNavigate()
  const { tempToken, tenants, accessToken } = useAuthStore()

  useEffect(() => {
    // Redirect if already authenticated
    if (accessToken) {
      navigate('/', { replace: true })
      return
    }

    // Redirect if no temp token or tenants
    if (!tempToken || !tenants.length) {
      navigate(AUTH_PATH.SIGN_IN, { replace: true })
      return
    }
  }, [accessToken, tempToken, tenants, navigate])

  if (!tempToken || !tenants.length) {
    return null
  }

  return <TenantSelection tenants={tenants} tempToken={tempToken} />
}
